(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('AssistantPanelController', AssistantPanelController);

    AssistantPanelController.$inject = ['$scope', '$window', '$timeout', '$translate', 'AssistantPanelService'];

    function AssistantPanelController($scope, $window, $timeout, $translate, AssistantPanelService) {
        var vm = this;
        var LONG_WAIT_DELAY_MS = 10000;
        var LONG_WAIT_ROTATION_DELAY_MS = 8000;
        var processingTimeouts = [];
        var longWaitTimer = null;
        var processingStepDefinitionsWithPlanner = [
            {delay: 0, key: 'global.assistant.processingAnalyzing'},
            {delay: 2200, key: 'global.assistant.processingPlanning'},
            {delay: 4500, key: 'global.assistant.processingCollectingData'},
            {delay: 7000, key: 'global.assistant.processingSendingContext'}
        ];
        var processingStepDefinitionsWithoutPlanner = [
            {delay: 0, key: 'global.assistant.processingAnalyzing'},
            {delay: 2200, key: 'global.assistant.processingPreparingContext'},
            {delay: 4500, key: 'global.assistant.processingCollectingData'},
            {delay: 7000, key: 'global.assistant.processingSendingContext'}
        ];
        var longWaitMessageKeys = [
            'global.assistant.longWait1',
            'global.assistant.longWait2',
            'global.assistant.longWait3',
            'global.assistant.longWait4',
            'global.assistant.longWait5',
            'global.assistant.longWait6',
            'global.assistant.longWait7',
            'global.assistant.longWait8',
            'global.assistant.longWait9',
            'global.assistant.longWait10'
        ];

        vm.state = AssistantPanelService.state;
        vm.askQuestion = askQuestion;
        vm.executeActions = executeActions;
        vm.close = close;
        vm.toggleMinimized = AssistantPanelService.toggleMinimized;
        vm.finishConversation = finishConversation;
        vm.dismissFeedbackPrompt = dismissFeedbackPrompt;
        vm.submitFeedback = submitFeedback;
        vm.beginUnsatisfiedFeedback = beginUnsatisfiedFeedback;
        vm.submitUnsatisfiedFeedback = submitUnsatisfiedFeedback;
        vm.toggleUsageDetails = toggleUsageDetails;
        vm.getUserUsagePercent = getUserUsagePercent;
        vm.getOrganisationUsagePercent = getOrganisationUsagePercent;
        vm.getUserUsageStatusClass = getUserUsageStatusClass;
        vm.getOrganisationUsageStatusClass = getOrganisationUsageStatusClass;
        vm.getUserUsageStatusLabel = getUserUsageStatusLabel;
        vm.getOrganisationUsageStatusLabel = getOrganisationUsageStatusLabel;
        vm.getUsagePeriodLabel = getUsagePeriodLabel;
        vm.getMaxOutputTokenOptions = getMaxOutputTokenOptions;
        vm.formatTokenUsage = formatTokenUsage;
        vm.formatTokenLimit = formatTokenLimit;
        vm.copyConversationDebugJson = copyConversationDebugJson;
        vm.supportsActionProposal = supportsActionProposal;
        vm.canConfigureDataScopes = canConfigureDataScopes;
        vm.supportsAssistantFlowModes = supportsAssistantFlowModes;
        vm.showExecutedActionsBlock = showExecutedActionsBlock;
        vm.showAdjustmentFollowUp = showAdjustmentFollowUp;
        vm.areProposedActionsReady = areProposedActionsReady;
        vm.handlePromptKeydown = handlePromptKeydown;
        vm.isScopeSelected = isScopeSelected;
        vm.toggleScope = toggleScope;
        vm.isInstructionDomainSelected = isInstructionDomainSelected;
        vm.toggleInstructionDomain = toggleInstructionDomain;
        vm.buildSentContextInfo = buildSentContextInfo;
        vm.openDocumentResult = openDocumentResult;

        $scope.$watch(function() {
            if (!vm.state.isOpen || !vm.state.context) {
                return null;
            }
            return vm.state.context.contextType + ':' + vm.state.context.entityId + ':' + (vm.state.context.llmModeEnabled ? '1' : '0');
        }, function(newValue) {
            if (newValue) {
                loadUsage();
            }
        });

        $scope.$watch(function() {
            return !!(vm.state.isOpen && !vm.state.isMinimized);
        }, function(isVisible) {
            if (isVisible) {
                schedulePromptFocus();
            }
        });

        function askQuestion() {
            send('QUESTION');
        }

        function handlePromptKeydown($event) {
            if (!$event || vm.state.isSending) {
                return;
            }
            if ($event.ctrlKey && ($event.key === 'Enter' || $event.keyCode === 13 || $event.which === 13)) {
                $event.preventDefault();
                askQuestion();
            }
        }

        function send(mode, actionContextType, allowEmptyPrompt) {
            var prompt = (vm.state.prompt || '').trim();
            var adapter = getAdapter();
            if (!adapter || vm.state.isSending) {
                return;
            }
            if (!allowEmptyPrompt && !prompt) {
                return;
            }
            if (allowEmptyPrompt && !prompt && !vm.state.messages.length) {
                return;
            }

            vm.state.errorMessage = null;
            if (prompt) {
                vm.state.messages.push({
                    role: 'user',
                    content: prompt,
                    exchangedAt: new Date().toISOString()
                });
                vm.state.userQuestionCount = vm.state.userQuestionCount + 1;
                vm.state.prompt = '';
            }
            vm.state.isSending = true;
            startProcessingFeedback();

            var payload = buildChatPayload(mode, actionContextType);
            var contextSignature = payload.contextSignature;
            delete payload.contextSignature;

            adapter.chat(payload, function(result) {
                applyAssistantResult(adapter, result, contextSignature);
            }, function(error) {
                stopProcessingFeedback();
                vm.state.isSending = false;
                vm.state.errorMessage = adapter.getErrorMessage ? adapter.getErrorMessage(error) : getTechnicalSupportErrorMessage();
            });
        }

        function executeActions(message) {
            var adapter = getAdapter();
            if (!adapter || !adapter.executeActions || !message || !message.proposedActions || !message.proposedActions.length || message.isExecutingActions) {
                return;
            }

            vm.state.errorMessage = null;
            message.isExecutingActions = true;

            adapter.executeActions({actions: message.proposedActions, conversationId: vm.state.conversationId}, function(result) {
                message.isExecutingActions = false;
                message.actionsExecuted = true;
                message.executedActionSummaries = result.executedActionSummaries || [];
                vm.state.conversationId = result.conversationId || vm.state.conversationId;
                vm.state.didExecuteActions = true;
                AssistantPanelService.invalidateConversationContext();
                if (adapter.refreshContextEntity) {
                    adapter.refreshContextEntity();
                }
            }, function(error) {
                message.isExecutingActions = false;
                vm.state.errorMessage = (error.headers && error.headers('X-wamasysApp-detail')) || 'Execution impossible';
            });
        }

        function finishConversation() {
            close('MANUAL_FINISH');
        }

        function close(trigger) {
            if (shouldPromptForFeedback()) {
                showFeedbackPrompt(trigger || 'WINDOW_CLOSE');
                vm.state.closeAfterFeedback = true;
                return;
            }
            stopProcessingFeedback();
            AssistantPanelService.close();
        }

        function showFeedbackPrompt(trigger) {
            vm.state.isMinimized = false;
            vm.state.feedbackPromptVisible = true;
            vm.state.feedbackPromptTrigger = trigger;
            vm.state.feedbackReasonPromptVisible = false;
        }

        function dismissFeedbackPrompt() {
            vm.state.feedbackPromptVisible = false;
            vm.state.feedbackPromptTrigger = null;
            vm.state.feedbackReasonPromptVisible = false;
            vm.state.feedbackComment = '';
            if (vm.state.closeAfterFeedback) {
                AssistantPanelService.close();
                return;
            }
            vm.state.closeAfterFeedback = false;
        }

        function submitFeedback(satisfied) {
            var adapter = getAdapter();
            var payload;
            if (!adapter || !adapter.submitFeedback || vm.state.feedbackSubmitted) {
                return;
            }
            payload = {
                satisfied: !!satisfied,
                questionCount: vm.state.userQuestionCount,
                trigger: vm.state.feedbackPromptTrigger || 'MANUAL_FINISH',
                responseId: vm.state.previousResponseId,
                conversationId: vm.state.conversationId,
                feedbackComment: satisfied ? null : ((vm.state.feedbackComment || '').trim() || null)
            };
            adapter.submitFeedback(payload, function() {
                vm.state.feedbackSubmitted = true;
                vm.state.closeAfterFeedback = false;
                vm.state.feedbackReasonPromptVisible = false;
                vm.state.feedbackComment = '';
                dismissFeedbackPrompt();
                AssistantPanelService.close();
            }, function(error) {
                vm.state.errorMessage = (error.headers && error.headers('X-wamasysApp-detail')) || 'Impossible d\'enregistrer votre retour';
            });
        }

        function beginUnsatisfiedFeedback() {
            vm.state.feedbackReasonPromptVisible = true;
            vm.state.isMinimized = false;
        }

        function submitUnsatisfiedFeedback() {
            submitFeedback(false);
        }

        function loadUsage() {
            var adapter = getAdapter();
            if (!adapter || !adapter.getUsage) {
                vm.state.latestUsage = null;
                vm.state.usageExpanded = false;
                return;
            }
            adapter.getUsage(function(result) {
                vm.state.latestUsage = result;
                initializeSelectedMaxOutputTokens(result);
                if (vm.state.context && vm.state.context.defaultUsageExpanded) {
                    vm.state.usageExpanded = true;
                }
            });
        }

        function toggleUsageDetails() {
            vm.state.usageExpanded = !vm.state.usageExpanded;
        }

        function buildChatPayload(mode, actionContextType) {
            var contextSignature = buildContextSignature();
            var payload = {
                contextType: vm.state.context.contextType,
                mode: mode,
                allowAssistantToChooseData: vm.state.allowAssistantToChooseData,
                selectedDataScopes: buildSelectedDataScopes(),
                selectedInstructionDomains: buildSelectedInstructionDomains(),
                responseDetailLevel: vm.state.responseDetailLevel,
                model: vm.state.selectedModel,
                creativityLevel: vm.state.creativityLevel,
                maxOutputTokens: vm.state.selectedMaxOutputTokens,
                assistantFlowMode: vm.state.selectedAssistantFlowMode,
                clientConversationId: vm.state.conversationId,
                previousResponseId: vm.state.lastContextSignature === contextSignature ? vm.state.previousResponseId : null,
                contextSignature: contextSignature,
                messages: vm.state.messages.map(function(message) {
                    return {
                        role: message.role,
                        content: message.content
                    };
                })
            };
            var adapter = getAdapter();
            if (adapter && adapter.extendChatPayload) {
                payload = adapter.extendChatPayload(payload) || payload;
            }
            payload.contextSignature = contextSignature;
            return payload;
        }

        function buildContextSignature() {
            var adapter = getAdapter();
            var adapterFragment = adapter && adapter.buildContextSignatureFragment ? adapter.buildContextSignatureFragment() : '';
            return [
                vm.state.context && vm.state.context.contextType,
                vm.state.context && vm.state.context.entityId,
                vm.state.allowAssistantToChooseData,
                buildSelectedDataScopes().join(','),
                buildSelectedInstructionDomains().join(','),
                vm.state.responseDetailLevel,
                vm.state.selectedModel,
                vm.state.creativityLevel,
                vm.state.selectedAssistantFlowMode,
                adapterFragment
            ].join('|');
        }

        function getAdapter() {
            return vm.state.context && vm.state.context.adapter ? vm.state.context.adapter : null;
        }

        function supportsActionProposal() {
            return !!(vm.state.context && vm.state.context.supportsActionProposal);
        }

        function canConfigureDataScopes() {
            return !!(vm.state.context && vm.state.context.supportsDataScopes);
        }

        function supportsAssistantFlowModes() {
            return !!(vm.state.context && vm.state.context.supportsAssistantFlowModes);
        }

        function buildSelectedDataScopes() {
            return angular.copy(vm.state.selectedDataScopes || []);
        }

        function buildSelectedInstructionDomains() {
            return angular.copy(vm.state.selectedInstructionDomains || []);
        }

        function isScopeSelected(scopeKey) {
            return (vm.state.selectedDataScopes || []).indexOf(scopeKey) !== -1;
        }

        function toggleScope(scopeKey) {
            toggleSelection(vm.state.selectedDataScopes, scopeKey);
        }

        function isInstructionDomainSelected(domainKey) {
            return (vm.state.selectedInstructionDomains || []).indexOf(domainKey) !== -1;
        }

        function toggleInstructionDomain(domainKey) {
            toggleSelection(vm.state.selectedInstructionDomains, domainKey);
        }

        function toggleSelection(collection, value) {
            var index;
            if (!collection || !value) {
                return;
            }
            index = collection.indexOf(value);
            if (index === -1) {
                collection.push(value);
                return;
            }
            collection.splice(index, 1);
        }

        function applyAssistantResult(adapter, result, contextSignature) {
            var message = {
                role: 'assistant',
                content: result.assistantMessage,
                exchangedAt: new Date().toISOString(),
                shouldSuggestAction: !!result.shouldSuggestAction,
                actionContextType: result.actionContextType,
                awaitingUserInput: !!result.awaitingUserInput,
                clarificationQuestions: result.clarificationQuestions || [],
                proposedActions: result.proposedActions || [],
                proposedActionSummaries: result.proposedActionSummaries || [],
                canExecuteActions: !!result.canExecuteActions,
                isExecutingActions: false,
                actionsExecuted: false,
                executedActionSummaries: [],
                suggestedFieldValues: result.suggestedFieldValues || {},
                selectedDataScopes: result.selectedDataScopes || [],
                selectedInstructionDomains: result.selectedInstructionDomains || [],
                plannerUsed: !!result.plannerUsed,
                sentContextSummary: result.sentContextSummary || null,
                debugExchange: result.debugExchange || null,
                assistantFlowMode: result.assistantFlowMode || vm.state.selectedAssistantFlowMode,
                documentResults: result.documentResults || []
            };

            if (result.usage) {
                vm.state.latestUsage = result.usage;
                initializeSelectedMaxOutputTokens(result.usage);
            }
            vm.state.previousResponseId = result.responseId || null;
            vm.state.conversationId = result.conversationId || vm.state.conversationId;
            vm.state.lastContextSignature = contextSignature;
            vm.state.errorMessage = null;
            vm.state.messages.push(message);
            stopProcessingFeedback();
            vm.state.isSending = false;

            if (adapter.applyAssistantResponse) {
                adapter.applyAssistantResponse(result, message);
            }
        }

        function getDefaultErrorMessage(error, fallbackMessage) {
            return (error && error.headers && error.headers('X-wamasysApp-detail')) || fallbackMessage;
        }

        function getTechnicalSupportErrorMessage() {
            return $translate.instant('global.assistant.technicalErrorSupport');
        }

        function schedulePromptFocus() {
            $timeout(function() {
                var promptElement = $window.document.querySelector('.assistant-panel__prompt-input');
                if (promptElement && angular.isFunction(promptElement.focus)) {
                    promptElement.focus();
                }
            }, 0, false);
        }

        function startProcessingFeedback() {
            stopProcessingFeedback();
            scheduleProcessingStepMessages();
            longWaitTimer = $timeout(function() {
                rotateLongWaitMessage(0);
            }, LONG_WAIT_DELAY_MS);
        }

        function stopProcessingFeedback() {
            while (processingTimeouts.length) {
                $timeout.cancel(processingTimeouts.pop());
            }
            if (longWaitTimer) {
                $timeout.cancel(longWaitTimer);
                longWaitTimer = null;
            }
            vm.state.processingStatus = null;
            vm.state.delayedProcessingMessage = null;
        }

        $scope.$on('$destroy', function() {
            stopProcessingFeedback();
        });

        function scheduleProcessingStepMessages() {
            var definitions = vm.state.allowAssistantToChooseData ? processingStepDefinitionsWithPlanner : processingStepDefinitionsWithoutPlanner;
            definitions.forEach(function(stepDefinition) {
                processingTimeouts.push($timeout(function() {
                    if (!vm.state.isSending) {
                        return;
                    }
                    vm.state.processingStatus = $translate.instant(stepDefinition.key);
                }, stepDefinition.delay));
            });
        }

        function rotateLongWaitMessage(index) {
            if (!vm.state.isSending) {
                return;
            }
            vm.state.delayedProcessingMessage = $translate.instant(longWaitMessageKeys[index % longWaitMessageKeys.length]);
            longWaitTimer = $timeout(function() {
                rotateLongWaitMessage(index + 1);
            }, LONG_WAIT_ROTATION_DELAY_MS);
        }

        function showExecutedActionsBlock(message) {
            return !!(message && message.actionsExecuted);
        }

        function showAdjustmentFollowUp(message) {
            return !!(message && message.actionsExecuted && containsActionType(message.proposedActions, 'CREATE_FINANCIAL_ADJUSTMENT')
                && !containsActionType(message.proposedActions, 'CLOSE_CONTRACT'));
        }

        function areProposedActionsReady(message) {
            return !!(message && message.proposedActions && message.proposedActions.length && message.proposedActions.every(function(action) {
                return action && action.actionReadiness === 'READY';
            }));
        }

        function containsActionType(actions, actionType) {
            return (actions || []).some(function(action) {
                return action && action.actionType === actionType;
            });
        }

        function getUserUsagePercent() {
            return percentage(vm.state.latestUsage && vm.state.latestUsage.currentMonthUserCostUsd, vm.state.latestUsage && vm.state.latestUsage.monthlyUserCostLimitUsd);
        }

        function getOrganisationUsagePercent() {
            return percentage(vm.state.latestUsage && vm.state.latestUsage.currentMonthOrganisationCostUsd,
                vm.state.latestUsage && vm.state.latestUsage.monthlyOrganisationCostLimitUsd);
        }

        function getUserUsageStatusClass() {
            return getUsageStatus(vm.state.latestUsage && vm.state.latestUsage.currentMonthUserCostUsd,
                vm.state.latestUsage && vm.state.latestUsage.monthlyUserCostLimitUsd).className;
        }

        function getOrganisationUsageStatusClass() {
            return getUsageStatus(vm.state.latestUsage && vm.state.latestUsage.currentMonthOrganisationCostUsd,
                vm.state.latestUsage && vm.state.latestUsage.monthlyOrganisationCostLimitUsd).className;
        }

        function getUserUsageStatusLabel() {
            return getUsageStatus(vm.state.latestUsage && vm.state.latestUsage.currentMonthUserCostUsd,
                vm.state.latestUsage && vm.state.latestUsage.monthlyUserCostLimitUsd).label;
        }

        function getOrganisationUsageStatusLabel() {
            return getUsageStatus(vm.state.latestUsage && vm.state.latestUsage.currentMonthOrganisationCostUsd,
                vm.state.latestUsage && vm.state.latestUsage.monthlyOrganisationCostLimitUsd).label;
        }

        function getUsagePeriodLabel() {
            if (!vm.state.latestUsage) {
                return '';
            }
            return [formatPeriodDate(vm.state.latestUsage.periodStart), formatPeriodDate(vm.state.latestUsage.periodEnd)]
                .filter(Boolean)
                .join(' -> ');
        }

        function percentage(currentValue, maxValue) {
            if (!maxValue) {
                return null;
            }
            return Math.min(100, Math.round(((currentValue || 0) / maxValue) * 100));
        }

        function getMaxOutputTokenOptions() {
            return (vm.state.latestUsage && vm.state.latestUsage.availableMaxOutputTokenOptions) || [];
        }

        function formatTokenUsage(currentValue, maxValue) {
            return Number(currentValue || 0).toFixed(4) + ' / ' + formatTokenLimit(maxValue) + ' USD';
        }

        function formatTokenLimit(limit) {
            return limit ? Number(limit).toFixed(2) : 'illimité';
        }

        function initializeSelectedMaxOutputTokens(usage) {
            if (!usage || vm.state.selectedMaxOutputTokens) {
                return;
            }
            vm.state.selectedMaxOutputTokens = usage.resolvedMaxOutputTokens || usage.configuredDefaultMaxOutputTokens || null;
        }

        function copyConversationDebugJson() {
            var debugPayload = buildConversationDebugPayload();
            var serialized = angular.toJson(debugPayload, true);
            copyText(serialized);
            vm.state.debugCopySuccess = true;
            $timeout(function() {
                vm.state.debugCopySuccess = false;
            }, 2000);
        }

        function buildConversationDebugPayload() {
            return {
                exportedAt: new Date().toISOString(),
                conversationId: vm.state.conversationId,
                exchanges: (vm.state.messages || []).map(function(message, index) {
                    return {
                        index: index,
                        exchangedAt: message.exchangedAt || null,
                        role: message.role,
                        content: message.content
                    };
                })
            };
        }

        function buildSentContextInfo(message) {
            var adapter = getAdapter();
            var sentContextSummary = message && message.sentContextSummary ? message.sentContextSummary : {};
            var scopes = sentContextSummary.selectedDataScopes || message.selectedDataScopes || [];
            var domains = sentContextSummary.selectedInstructionDomains || message.selectedInstructionDomains || [];
            var parts = [];
            if (adapter && adapter.buildSentContextInfo) {
                return adapter.buildSentContextInfo(message) || '';
            }
            if (message && message.plannerUsed) {
                parts.push($translate.instant('global.assistant.sentContextPlannerUsed'));
            } else {
                parts.push($translate.instant('global.assistant.sentContextPlannerSkipped'));
            }
            if (scopes.length) {
                parts.push($translate.instant('global.assistant.sentContextScopes') + ': ' + scopes.join(', '));
            }
            if (domains.length) {
                parts.push($translate.instant('global.assistant.sentContextRules') + ': ' + domains.join(', '));
            }
            return parts.join(' | ');
        }

        function openDocumentResult(result) {
            var adapter = getAdapter();
            if (!adapter || !adapter.openDocumentResult || !result) {
                return;
            }
            adapter.openDocumentResult(result);
        }

        function copyText(text) {
            var textarea;
            if ($window.navigator && $window.navigator.clipboard && $window.isSecureContext) {
                $window.navigator.clipboard.writeText(text);
                return;
            }
            textarea = $window.document.createElement('textarea');
            textarea.value = text;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'fixed';
            textarea.style.left = '-9999px';
            $window.document.body.appendChild(textarea);
            textarea.select();
            $window.document.execCommand('copy');
            $window.document.body.removeChild(textarea);
        }

        function shouldPromptForFeedback() {
            var adapter = getAdapter();
            return !!(adapter && adapter.submitFeedback && !vm.state.feedbackSubmitted && hasAtLeastOneUserMessage());
        }

        function hasAtLeastOneUserMessage() {
            return (vm.state.messages || []).some(function(message) {
                return message && message.role === 'user' && message.content;
            });
        }

        function getUsageStatus(currentValue, maxValue) {
            var remainingRatio;
            var remainingPeriodRatio;
            var proratedRemainingPercent;
            if (!maxValue) {
                return {
                    label: '-',
                    className: 'assistant-panel__usage-pill assistant-panel__usage-pill--neutral'
                };
            }
            remainingRatio = Math.max(0, (maxValue - (currentValue || 0)) / maxValue);
            remainingPeriodRatio = getRemainingPeriodRatio();
            proratedRemainingPercent = remainingPeriodRatio > 0 ? (remainingRatio / remainingPeriodRatio) * 100 : (remainingRatio > 0 ? 100 : 0);
            if (proratedRemainingPercent > 50) {
                return {
                    label: 'OK',
                    className: 'assistant-panel__usage-pill assistant-panel__usage-pill--success'
                };
            }
            if (proratedRemainingPercent >= 25) {
                return {
                    label: 'Warning',
                    className: 'assistant-panel__usage-pill assistant-panel__usage-pill--warning'
                };
            }
            return {
                label: 'Critique',
                className: 'assistant-panel__usage-pill assistant-panel__usage-pill--danger'
            };
        }

        function getRemainingPeriodRatio() {
            var now = new Date();
            var start = new Date(now.getFullYear(), now.getMonth(), 1);
            var end = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);
            var total = Math.max(1, end.getTime() - start.getTime());
            return Math.max(0, (end.getTime() - now.getTime()) / total);
        }

        function formatPeriodDate(value) {
            var date;
            if (!value) {
                return '';
            }
            date = new Date(value);
            if (isNaN(date.getTime())) {
                return value;
            }
            return [
                ('0' + date.getDate()).slice(-2),
                ('0' + (date.getMonth() + 1)).slice(-2),
                date.getFullYear()
            ].join('/');
        }

    }
})();
